/**
 * Tipos de mensajes soportados por el sistema
 * @enum {string}
 */
export enum MessageType {
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
  INFO = 'info'
}

/**
 * Posiciones horizontales disponibles para el snackbar
 * @type
 */
export type HorizontalPosition = 'start' | 'center' | 'end' | 'left' | 'right';

/**
 * Posiciones verticales disponibles para el snackbar
 * @type
 */
export type VerticalPosition = 'top' | 'bottom';

/**
 * Opciones para configurar el manejo de mensajes del sistema
 * @interface HandlerMessageOptions
 */
export interface HandlerMessageOptions {
  /**
   * Mensaje principal (puede venir del backend o ser definido localmente)
   * @type {string}
   * @optional
   */
  message?: string;

  /**
   * Mensaje alternativo si no hay message disponible
   * @type {string}
   * @optional
   */
  alternativeMessage?: string;

  /**
   * Código HTTP del error (principalmente para errores)
   * @type {number}
   * @optional
   */
  statusCode?: number;

  /**
   * Duración en milisegundos que se mostrará el snackbar.
   * Si no se proporciona o es menor a 5000ms, se usará el valor por defecto de 5000ms.
   * @type {number}
   * @optional
   * @default 5000
   * @minimum 5000
   */
  duration?: number;

  /**
   * Tipo de mensaje
   * @type {MessageType}
   * @optional
   */
  type?: MessageType;

  /**
   * Posición horizontal del snackbar
   * @type {HorizontalPosition}
   * @optional
   * @default 'center'
   */
  horizontalPosition?: HorizontalPosition;

  /**
   * Posición vertical del snackbar
   * @type {VerticalPosition}
   * @optional
   * @default 'bottom'
   */
  verticalPosition?: VerticalPosition;
}

/**
 * Mantener compatibilidad con la interfaz anterior
 * @deprecated Use HandlerMessageOptions instead
 */
export type HandlerErrorOptions = HandlerMessageOptions;

